import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "all-businesses" }
const _hoisted_2 = { class: "all-businesses__top-area top-area" }
const _hoisted_3 = { class: "top-area__button-area button-area" }
const _hoisted_4 = { class: "edit-button__container" }
const _hoisted_5 = { class: "edit-button__text" }
const _hoisted_6 = { class: "download-button__container" }
const _hoisted_7 = { class: "download-button__text" }
const _hoisted_8 = { class: "all-businesses__table-area table-area" }
const _hoisted_9 = { class: "table-area__top-accessory" }
const _hoisted_10 = { class: "table-area__select-month-area select-month-area" }
const _hoisted_11 = { class: "select-month-area__title" }
const _hoisted_12 = {
  key: 0,
  class: "table-area__business-table table-area__business-table--zero-match"
}

import { i18n } from '@/i18n';
import ControlSupplierPageTab from '../components/ControlSupplierPageTab.vue';
import { SUPPLIER_TAB_ROUTER_INFO } from '../constants';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { useAllBusinessesForSupplierForecastStore } from './useAllBusinessesForSupplierForecastStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, onMounted } from 'vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import SelectInput from '@/corePagesModule/SelectInput';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import EditForecastModal from '../components/EditForecastModal.vue';
import DownloadForecastModal from '../components/DownloadForecastModal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';


export default /*@__PURE__*/_defineComponent({
  __name: 'AllBusinessesForSupplierForecast',
  setup(__props) {

const t = i18n.t;
const locale = computed(() => i18n.locale);
const store = useAllBusinessesForSupplierForecastStore();
const { state } = storeToRefs(store);

onBeforeMount(() => {
  store.init();
});

const monthsOptionsDisplayForecast = computed(() => {
  return store.monthsOptionsDisplayForecastNumber.map((monthsOption) => monthsOption + t('unitMonth'));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(FilterModalButton, {
        "filter-modal-type": 'supplierForecast',
        "select-input-index": 1,
        "filter-items": _unref(store).getFilterItemsValue().value,
        onApply: _cache[0] || (_cache[0] = (filteredContents) => _unref(store).onAppliedFilterModal(filteredContents))
      }, null, 8, ["filter-items"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TextButton, {
            class: "button-area__edit-button edit-button button-area__button button-area__button--fill btn-primary",
            disabled: _unref(store).isDisabledEditButton,
            onClick: _unref(store).onClickEditButton
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('担当者編集')), 1),
                _createVNode(SvgLoader, {
                  class: "edit-button__icon",
                  name: "editPen"
                })
              ])
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "onClick"]),
          (_unref(state).editForecastModalState.modalState)
            ? (_openBlock(), _createBlock(EditForecastModal, {
                key: 0,
                class: "button-area__edit-button",
                store: _unref(store),
                "index-of-select-input": 21
              }, null, 8, ["store"]))
            : _createCommentVNode("", true),
          _createVNode(TextButton, {
            class: "button-area__download-button download-button button-area__button button-area__button--white btn-primary",
            disabled: _unref(store).isDisabledOpenDownloadModal,
            onClick: _unref(store).onClickDownloadButton
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('全てダウンロード')), 1),
                _createVNode(SvgLoader, {
                  class: "download-button__icon",
                  name: "fatArrowDown"
                })
              ])
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "onClick"]),
          (_unref(state).downloadForecastModalState.modalState)
            ? (_openBlock(), _createBlock(DownloadForecastModal, {
                key: 1,
                class: "button-area__download-button",
                store: _unref(store),
                "index-of-select-input": 22
              }, null, 8, ["store"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('内示作成月')), 1),
            _createVNode(MonthPicker, {
              class: "select-month-area__calendar",
              "model-value": _unref(state).yearMonthInfoCreatedForecast,
              locale: locale.value,
              "prop-format": _unref(t)('MonthPickerFormat'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(store).onSelectedCreatedMonth($event)))
            }, null, 8, ["model-value", "locale", "prop-format"])
          ]),
          (_unref(state).businessTableContents.pagingOptions)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 0,
                "paging-options": _unref(state).businessTableContents.pagingOptions,
                "is-loading": _unref(state).businessTableContents.loadingState.status.type === 'loading',
                class: "table-area__pagination",
                onOnChangePage: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).onChangePaging($event)))
              }, null, 8, ["paging-options", "is-loading"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(SelectInput), {
            class: "table-area__forecast-length-select",
            index: 23,
            "model-value": _unref(t)('displayMonthsOfData', { month: _unref(state).monthsDisplayForecast }),
            placeholder: '',
            label: '',
            "filter-type": 'DISPLAY_MONTH',
            "prop-options": monthsOptionsDisplayForecast.value,
            "is-open-prop": _unref(state).isOpenSelectInputType === 'DISPLAY_MONTH',
            "use-teleport": "",
            "onClick:selectInput": _cache[3] || (_cache[3] = () => (_unref(state).isOpenSelectInputType = 'DISPLAY_MONTH')),
            "onUpdate:valueWithIndex": _cache[4] || (_cache[4] = (_, index) => _unref(store).onSelectedMonthsDisplayForecast(index))
          }, null, 8, ["model-value", "prop-options", "is-open-prop"])
        ]),
        (_unref(state).businessTableContents.loadingState.status.type === 'zeroMatch')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)('取引が存在しません')), 1))
          : (_openBlock(), _createBlock(NewBaseTableContent, {
              key: _unref(state).businessTableContents.renderingKey,
              class: "table-area__business-table table-area__business-table--success",
              "prop-table-content-properties": _unref(state).businessTableContents.contentHeader,
              "prop-display-objects": _unref(state).businessTableContents.contentItems,
              "prop-loading-status": _unref(state).businessTableContents.loadingState,
              "prop-table-type": 'supplierForecastAllBusinessTable',
              onChecked: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).businessTableContents.checkedDisplayIds = $event)),
              onOnClickSort: _cache[6] || (_cache[6] = (sortKey) => _unref(store).sortTableContentItems(sortKey)),
              onOnClickFilter: _cache[7] || (_cache[7] = (narrowState) => _unref(store).filterTableContentItems(narrowState))
            }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
      ])
    ]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).downloadForecastModalState.loadingState.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('仕入先内示をダウンロード中です。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"])
  ], 64))
}
}

})